const locale = {
    placeholder: 'اختيار الوقت',
    rangePlaceholder: ['وقت البدء', 'وقت الانتهاء'],
};
export default locale;
